export default {
      id: "oc-language-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-language",
      toString: function () {
        return this.url;
      }
    }